import { render, staticRenderFns } from "./ProductPricesFields.vue?vue&type=template&id=785fb13c"
import script from "./ProductPricesFields.vue?vue&type=script&lang=js"
export * from "./ProductPricesFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports